import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import { authAction } from './authSlice';

import * as authApiLib from '../lib/authApi';

import dayjs from 'dayjs';

function* handleLogin({ payload }) {
  try {
    if (payload.idSave === 'Y') {
      localStorage.setItem('loginId', payload.accountAlias ? payload.accountAlias : payload.loginId);
      localStorage.setItem('idSave', 'Y');
    } else {
      localStorage.setItem('loginId', '');
      localStorage.setItem('idSave', 'N');
    }

    const result = yield call(authApiLib.login, payload);

    const loginInfo = result;
    loginInfo.lastLoginDt = dayjs(loginInfo.lastLoginDt).format(
      'YYYY-MM-DD HH:mm:ss',
    );

    localStorage.setItem('accessToken', result.accessToken);

    yield put(authAction.loginSuccess({ loginInfo }));
  } catch (err) {
    localStorage.removeItem('accessToken');
    yield put(authAction.loginFailure('Login Error'));
  }
}

function* handleToken() {
  try {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      throw Object.assign(new Error('token error'), { status: 401 });
    }

    const data = {
      accessToken: accessToken,
    };

    const result = yield call(authApiLib.token, data);

    const loginInfo = result;
    loginInfo.lastLoginDt = dayjs(loginInfo.lastLoginDt).format(
      'YYYY-MM-DD HH:mm:ss',
    );

    yield put(authAction.tokenSuccess({ loginInfo }));
  } catch (err) {
    localStorage.removeItem('accessToken');
    yield put(authAction.tokenFailure('Token Error'));
  }
}

function* handleKraftonToken({ payload }) {
  try {
    const result = yield call(authApiLib.kraftonToken, payload);

    const loginInfo = result;
    loginInfo.lastLoginDt = dayjs(loginInfo.lastLoginDt).format(
      'YYYY-MM-DD HH:mm:ss',
    );

    localStorage.setItem('accessToken', loginInfo.accessToken);

    yield put(authAction.kraftonTokenSuccess({ loginInfo }));
  } catch (err) {
    localStorage.removeItem('accessToken');
    yield put(authAction.kraftonTokenFailure('Token Error'));
  }
}

function* handleLogout({ payload }) {
  try {
    localStorage.removeItem('accessToken');

    yield put(authAction.logoutSuccess());
  } catch (err) {
    yield put(authAction.logoutFailure('Logout Error'));
  }
}

export function* watchLogin() {
  yield takeLatest(authAction.login, handleLogin);
}

export function* watchToken() {
  yield takeLatest(authAction.token, handleToken);
}

export function* watchKraftonToken() {
  yield takeLatest(authAction.kraftonToken, handleKraftonToken);
}

export function* watchLogout() {
  yield takeLatest(authAction.logout, handleLogout);
}

function* rootSaga() {
  yield all([
    fork(watchLogin),
    fork(watchToken),
    fork(watchKraftonToken),
    fork(watchLogout),
  ]);
}

export default rootSaga;
